import Axios from "@/plugins/Axios";

export class PlanosBimestraisInfantil {
  async planoBimestral(gestaoDeAulaId, bimestre) {
    const response = await Axios().get(
      `planos-bimestrais-infantil/plano-bimestral/${gestaoDeAulaId}/${bimestre}`
    );
    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-bimestrais-infantil/criar-plano-bimestral`, {
      plano,
    });
    return response.data;
  }

  async disciplinas() {
    const response = await Axios().get(`/disciplinas`);
    return response;
  }

  async turmasInfantil() {
    const response = await Axios().get(`planos-bimestrais-infantil/turmas-infantil`);
    return response;
  }

  async bimestresInfantil() {
    const response = await Axios().get(`planos-bimestrais-infantil/listar-bimestres-infantil`);
    return response;
  }

  async indexInfantil(pageNumber, query, turma, disciplina) {
    const planos = await Axios().get(
      `planos-bimestrais-infantil/planos-bimestrais-infantil?page=${pageNumber}&query=${query}&turma=${turma}&disciplina=${disciplina}`
    );
    return planos.data;
  }

  async pdfInfantil(planoId) {
    const base64 = await Axios()
      .get(`planos-bimestrais-infantil/${planoId}/relatorio`, {
        responseType: "arraybuffer",
      })
      .then((response) => Buffer.from(response.data, "binary").toString("base64"));

    return `data:application/pdf;base64, ${base64}`;
  }

  async showInfantil(planoId) {
    const response = await Axios().get(`planos-bimestrais-infantil/${planoId}/visualizar`);
    return response;
  }

  async updateInfantil(planoId, statusId) {
    const response = await Axios().put(
      `planos-bimestrais-infantil/${planoId}/${statusId}/atualizarSituacao`
    );
    return response.data;
  }

  async planoBimestralPDFInfantil(gestaoDeAulaId, bimestre, file) {
    const formData = new FormData();
    formData.append("file", file);

    const response = await Axios().post(
      `planos-bimestrais-infantil/uploadPdf/${gestaoDeAulaId}/${bimestre}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const resultData = response.data ?? response;
    if (resultData) {
      return resultData;
    }
    return null;
  }

  async planoBimestralDownload(gestaoDeAulaId, bimestre) {
    const response = await Axios()
      .get(`planos-bimestrais-infantil/downloadPdf/${gestaoDeAulaId}/${bimestre}`, {
        responseType: "blob",
      })
      .then((response) => {
        const a = document.createElement("a");
        a.href = window.URL.createObjectURL(response.data);
        window.open(a.href);
      });

    return response;
  }

  async pdfAnexado(planoId) {
    const base64 = await Axios()
      .get(`planos-bimestrais-infantil/${planoId}/relatorioAnexado`, {
        responseType: "arraybuffer",
      })
      .then((response) => Buffer.from(response.data, "binary").toString("base64"));
    return `data:application/pdf;base64, ${base64}`;
  }
}

export default new PlanosBimestraisInfantil();
